import Vue from 'vue'
import baseApplicationItem from './baseApplicationItem'
import {merge} from 'lodash'

var module = {
  endpoint: 'inventary',
  getNew: {
    id: null,
    deleted: false,
    customer: {},
    products: [],
    totalAmount: 0,
    currency: {
      name: 'EURO',
      symbol: '€'
    }
  },
  tableInfo: {
    tableFields: [
      {
        name: '__component:badge-deleted-column',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__checkbox',
        title: '',
        class: 'primary'
      },
      {
        name: 'id',
        title: 'id',
        sortField: 'id'
      },
      {
        name: 'createdAt',
        title: 'Data Creazione',
        sortField: 'createdAt',
        callback: baseApplicationItem.toDate
      },
      {
        name: 'name',
        title: 'Nome',
        sortField: 'name'
      },
      {
        name: '__component:action-review',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__component:action-download',
        title: '',
        dataClass: 'text-center'
      },
      {
        name: '__component:action-preview',
        title: '',
        dataClass: 'text-center'
      }
    ],
    sortFunctions: {
    },
  },
  async generateInventary () {
    let url = `${this.endpoint}/generate`
    let inventary = (await Vue.http.put(url)).body
    return inventary
  }
}

export default merge(module, baseApplicationItem)



// WEBPACK FOOTER //
// ./src/application/inventaries.js